// Setup de react-i18next para el texto fijo del código (botones, labels,
// mensajes) de la app pública. Por ahora el diccionario solo cubre el
// namespace "inscripcion" (EventRegistryPublicForm.jsx y sus hijos
// directos) — el resto de la app sigue con texto hardcodeado en español,
// se migra a futuro conforme se vayan cubriendo más pantallas.
//
// El idioma inicial se detecta del navegador (navigator.language) entre
// los idiomas que YA existen en este diccionario (es/en) — esto es un
// detector genérico, sin conocer todavía qué idiomas habilitó el
// organizador para un evento en concreto, ni si el visitante ya eligió
// uno a mano antes. Eso lo resuelve useIdiomaEvento (más adelante en el
// plan), que vuelve a llamar a i18n.changeLanguage(...) una vez que sabe
// la lista de idiomas disponibles del evento + localStorage.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import inscripcionEs from "./locales/es/inscripcion.json";
import inscripcionEn from "./locales/en/inscripcion.json";

const resources = {
  es: { inscripcion: inscripcionEs },
  en: { inscripcion: inscripcionEn },
};

function detectarIdiomaNavegador() {
  const idiomasDisponibles = Object.keys(resources);
  const idiomaNavegador = (
    (typeof navigator !== "undefined" &&
      (navigator.language || navigator.userLanguage)) ||
    "es"
  )
    .toLowerCase()
    .split("-")[0];
  return idiomasDisponibles.includes(idiomaNavegador) ? idiomaNavegador : "es";
}

i18n.use(initReactI18next).init({
  resources,
  lng: detectarIdiomaNavegador(),
  fallbackLng: "es",
  defaultNS: "inscripcion",
  interpolation: {
    escapeValue: false, // React ya escapa por su cuenta
  },
});

export default i18n;
